import _ from 'lodash';
import { useContext } from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../store/context/DialogContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import { collectVisibleFieldErrors, getFirstErrorInFieldOrder, getNextStepV2, getVisibleWizardFieldOrder } from './helperV2';

const FUND_FAMILY_OFFICES_RENDER_ORDER = [
    "distributeFunds",
    "institutionTypes",
    "institutionTypesOther",
    "requiresFundLicense",
    "hasFundLicense",
    "licenseHolderDetails",
    "subsidiesOrSubventions",
    "assets",
];

const FundFamilyOffices = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    editMode,
    jsonConfig,
    pageNum = 1,
}) => {
    const { showError } = useContext(DialogContext);

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
            type: Number(applicationForm?.type),
        });
        const renderedFieldOrder = FUND_FAMILY_OFFICES_RENDER_ORDER.filter((field) => visibleFieldOrder.includes(field));
        const { fieldErrors } = collectVisibleFieldErrors({
            data,
            step: { wizard },
            iPlusFields,
            errors,
            type: Number(applicationForm?.type),
        });
        const mergedErrors = {
            ...(errors || {}),
            ...fieldErrors,
        };
        setErrors(mergedErrors);

        const firstError = getFirstErrorInFieldOrder(renderedFieldOrder, mergedErrors);
        if (firstError?.message) {
            setHasError(true);
            showError(firstError.message);
            return false;
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStepV2(wizard, Number(applicationForm?.type), data, jsonConfig) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className="business-v2-step-shell">
                <div className="business-v2-step-header">
                    <h2 className='business-v2-step-title'>Funds and Family Offices</h2>
                </div>

                <div className='business-v2-step-form-stack'>
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["distributeFunds"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('distributeFunds', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["institutionTypes"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('institutionTypes', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["institutionTypesOther"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('institutionTypesOther', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["requiresFundLicense"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('requiresFundLicense', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasFundLicense"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasFundLicense', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["licenseHolderDetails"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('licenseHolderDetails', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["subsidiesOrSubventions"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('subsidiesOrSubventions', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["assets"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('assets', errorMsg)}
                    isForEDD={isForEDD}
                />
                </div>

                <div className='business-v2-step-actions'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={pageNum}
                        hideSubmitButton={hideButtons}
                        showPageNum={false}
                        pageNum={pageNum}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
        </div>
    );
};

export default FundFamilyOffices;
